/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestAudioApps from "views/articles/BestAudioApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"

const Article = ({ apps }: { apps: AppInterface[] }) => {
  const article = BestAudioApps["tr"]
  return (
    <InstantArticle {...article}>
      <div dir="ltr" style={{ textAlign: "justify" }}>
        <p>
          iPhone veya iPad&apos;iniz için en iyi ses düzenleme ve kesme
          uygulamalarını mı arıyorsunuz? İşte, tüm ses düzenleme ihtiyaçlarınıza
          hitap eden benzersiz özelliklerle donatılmış en iyi 4 uygulamanın bir
          listesini hazırladık. M4a&apos;dan mp3&apos;e, youtube&apos;dan
          wav&apos;a ve mp3&apos;ten wave&apos;e dönüştürme işlemlerini bu
          uygulamalarla gerçekleştirebilirsiniz. Hadi, sizin için mükemmel
          uygulamayı bulalım!
        </p>

        <h2>Lexis Audio Editor</h2>
        <p>
          Lexis Audio Editor, iOS cihazlar için çok yönlü bir ses düzenleme ve
          birleştirme uygulamasıdır. Bu güçlü araç, ses dosyalarını kesme,
          sıkıştırma ve birleştirme işlemleri için kullanıcı dostu bir arayüz
          sunarak hem başlangıç düzeyinde hem de ileri düzey kullanıcılar için
          mükemmeldir.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1259401721)} />
        </div>

        <h2>Hokusai Audio Editor</h2>
        <p>
          Hokusai Audio Editor, hızlıca ses dosyalarını düzenleme ve kesme
          işlemleri için sezgisel bir uygulamadır. Vokal kaldırma özelliği
          sayesinde, favori şarkılarınızdan karaoke parçaları oluşturabilir veya
          kayıtlarınızdaki istenmeyen arka plan gürültüsünü kaldırabilirsiniz.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 432079746)} />
        </div>

        <h2>The Audio Converter</h2>
        <p>
          Bu uygulama, m4a&apos;dan mp3&apos;e dönüştürme işlemlerinde
          uzmanlaşmıştır ve ses formatları arasında geçiş yapmak zorunda olanlar
          için vazgeçilmez bir araçtır. Kullanıcı dostu arayüzü ve hızlı dönüşüm
          süreci, iPhone ve iPad kullanıcıları arasında favori olmasını
          sağlamaktadır.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 889643660)} />
        </div>

        <h2>Audio Trimmer - Trim Audio</h2>
        <p>
          Audio Trimmer, ses dosyalarınızı paylaşmak veya depolamak için
          optimize etmenize yardımcı olan güçlü bir ses düzenleme ve kesme
          uygulamasıdır. Basit arayüzü sayesinde, ses dosyalarınızı kolayca
          kesebilir ve ihtiyacınız olan kesin bölümü kaydedebilirsiniz.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1602845668)} />
        </div>
        <br />
        <div className="card mt-4 mb-1">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              iPhone ve iPad için favori ses düzenleme ve kesme uygulamalarınız
              var mı? En sevdiğiniz uygulamaları,{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  Paylaşma Sayfası
                </span>
              </Link>{" "}
              üzerinden paylaşabilirsiniz.
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default Article
